module.exports = __webpack_public_path__ + "img/fractel-logo-full.3c4cad5a.png";